import { Checkbox } from "@mui/material";
import { ColumnDef } from "@tanstack/react-table";
import { Eye, Link2, Shield, ShieldOff } from "lucide-react";
import i18n from "@lib/i18n";
import { Unit } from "@lib/types/units";
import ActionButton from "@components/ActionButton";
import { cn } from "@lib/utils/tailwind";

export const columns = (
  viewRowDetails: (unitDetails: Unit) => void,
  toggleAuthorization: (unitDetails: Unit) => void
): ColumnDef<Unit>[] => [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllRowsSelected()}
        indeterminate={table.getIsSomeRowsSelected()}
        onChange={() => table.toggleAllRowsSelected()}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onChange={() => row.toggleSelected()}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
    meta: { hideOnSmallScreens: true },
  },
  {
    accessorKey: "unit_id",
    header: i18n.t("table.unitId"),
    cell: ({ row }) => (
      <span className="text-neutral-600 leading-none font-book text-base">
        {row.original.unit_id}
      </span>
    ),
    enableSorting: true,
    meta: { hideOnSmallScreens: true },
  },

  {
    accessorKey: "name",
    header: i18n.t("table.name"),
    cell: ({ row }) => (
      <span className="text-neutral-600 leading-none font-book text-base">
        {row.original.name}
      </span>
    ),
    enableSorting: true,
  },
  {
    id: "actions",
    header: i18n.t("table.actions"),
    enableHiding: false,
    cell: ({ row }) => {
      return (
        <div className="flex w-full items-center justify-center gap-1">
          <ActionButton
            title={i18n.t("general.view")}
            onClick={() => viewRowDetails(row.original)}
          >
            <Eye size={20} />
          </ActionButton>

          <ActionButton
            title={i18n.t("user.units.toggleAuthorizationStatus")}
            onClick={() => {
              toggleAuthorization(row.original);
            }}
            className={cn(row.original.unit_id ? "block" : "opacity-0")}
            disabled={!row.original.iccid}
          >
            {row.original.authorization_status === "1" ? (
              <Shield size="20" color="green" />
            ) : (
              <ShieldOff size="20" color="red" />
            )}
          </ActionButton>
        </div>
      );
    },
  },
];
